import { Action } from '@ngrx/store';
import { IUser } from "../../models/user.model";
import { SocialUser } from 'angular5-social-login';

export const VERIFY_AUTH = '[auth] verify auth';
export const AUTHENTICATED = '[auth] authenticated';
export const NOT_AUTHENTICATED = '[auth] not authenticated';

export const SIGN_UP = '[auth] sign up';
export const SIGN_UP_SUCCESS = '[auth] sign up success';
export const SIGN_UP_FAILED = '[auth] sign up failed';

export const LOGIN_TOKEN_CUSTOM = '[auth] login Custom token to app';
export const LOGIN_SOCIAL_CUSTOM = '[auth] login Custom to new integration general login social to app';
export const LOGIN_EMAIL_CUSTOM = '[auth] login Custom to new integration general login email to app';

export const LOGIN_RESTORE_PASSWORD = '[auth] login restore password';
export const LOGIN_SUCCESS = '[auth] login success';
export const LOGIN_FAILED = '[auth] login failed';

export const LOGOUT = '[auth] logout';

export const UPDATE_PROFILE = '[auth] update profile';
export const UPDATE_PROFILE_SUCCESS = '[auth] update profile success';
export const UPDATE_PROFILE_FAILED = '[auth] update profile failed';

export const CHANGE_AVATAR = '[auth] change avatar';

export class VerifyAuth implements Action {
  public readonly type = VERIFY_AUTH;
  public constructor() { }
}

export class Authenticated implements Action {
  public readonly type = AUTHENTICATED;
  public constructor(public payload: IUser) { }
}

export class NotAuthenticated implements Action {
  public readonly type = NOT_AUTHENTICATED;
  public constructor(public payload?: any) { }
}

export class SignUp implements Action {
  public readonly type = SIGN_UP;
  public constructor(public payload: { email: string, displayName: string, password: string }) { }
}

export class SignUpSuccess implements Action {
  public readonly type = SIGN_UP_SUCCESS;
  public constructor(public payload: IUser) { }
}

export class SignUpFailed implements Action {
  public readonly type = SIGN_UP_FAILED;
  public constructor(public payload?: any) { }
}

export class LoginSocialCustom implements Action {
  public readonly type = LOGIN_SOCIAL_CUSTOM;
  public constructor(public payload: any ) { }
}

export class LoginEmailCustom implements Action {
  public readonly type = LOGIN_EMAIL_CUSTOM;
  public constructor(public payload: { email: string, password: string } ) { }
}

export class LoginTokenCustom implements Action {
  public readonly type = LOGIN_TOKEN_CUSTOM;
  public constructor(public payload: any ) { }
}

export class LoginSuccess implements Action {
  public readonly type = LOGIN_SUCCESS;
  public constructor(public payload: IUser) { }
}

export class LoginRestorePassword implements Action {
  public readonly type = LOGIN_RESTORE_PASSWORD;
  public constructor(public payload?: any) { }
}

export class LoginFailed implements Action {
  public readonly type = LOGIN_FAILED;
  public constructor(public payload?: any) { }
}

export class Logout implements Action {
  public readonly type = LOGOUT;
  public constructor() { }
}

export class UpdateProfile implements Action {
  public readonly type = UPDATE_PROFILE;
  public constructor(public payload: any) { }
}

export class UpdateProfileSuccess implements Action {
  public readonly type = UPDATE_PROFILE_SUCCESS;
  public constructor(public payload: IUser) { }
}

export class UpdateProfileFailed implements Action {
  public readonly type = UPDATE_PROFILE_FAILED;
  public constructor(public payload?: any) { }
}

export class ChangeAvatar implements Action {
  public readonly type = CHANGE_AVATAR;
  public constructor(public payload: File) { }
}

export type All
  = VerifyAuth
  | Authenticated
  | NotAuthenticated
  | SignUp
  | SignUpSuccess
  | SignUpFailed
  | LoginSuccess
  | LoginSocialCustom
  | LoginTokenCustom
  | LoginRestorePassword
  | LoginEmailCustom
  | LoginFailed
  | Logout
  | UpdateProfile
  | UpdateProfileSuccess
  | UpdateProfileFailed
  | ChangeAvatar;



// WEBPACK FOOTER //
// ./src/ngrx/actions/auth.actions.ts